import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/admin/PageHeader";
import { ShippingPartnersSection } from "@/components/admin/ShippingPartners";

export const Route = createFileRoute("/admin/shipping-partners")({
  head: () => ({
    meta: [
      { title: "Shipping Partners — CB16 Admin" },
      { name: "description", content: "Manage the couriers available for order shipping." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Shipping Partners — CB16 Admin" },
      { property: "og:description", content: "Manage the couriers available for order shipping." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ShippingPartnersPage,
});

function ShippingPartnersPage() {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader title="Shipping partners" subtitle="Couriers available in the order shipping dropdown" />
      <ShippingPartnersSection />
    </div>
  );
}
